import { render, staticRenderFns } from "./Logout.vue?vue&type=template&id=53525a62&"
import script from "./Logout.vue?vue&type=script&lang=js&"
export * from "./Logout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/classleasingtraffic.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53525a62')) {
      api.createRecord('53525a62', component.options)
    } else {
      api.reload('53525a62', component.options)
    }
    module.hot.accept("./Logout.vue?vue&type=template&id=53525a62&", function () {
      api.rerender('53525a62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/App/Logout.vue"
export default component.exports